// extracted by mini-css-extract-plugin
export default {"website-content":"WebsiteTag_website-content__9rqfp"};